import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * White label header (concept 9.1).
 *
 * The logo of the TENANT, on the TENANT's domain, never a mark of the platform
 * operator. Without a logo a name is rendered as text, unless the action hides it;
 * the footer's imprint still names the operator. With neither a mark nor controls
 * there is no header.
 */
export function TenantBrandHeader({ logo, name, homeHref = '/', className, children, }) {
    const classNames = ['countdown-brand-header', className].filter(Boolean).join(' ');
    const hasMark = logo !== null || name !== '';
    const hasControls = children !== undefined && children !== null;
    if (!hasMark && !hasControls) {
        return null;
    }
    return (_jsxs("header", { className: classNames, "data-logo-placement": logo?.placement ?? 'left', children: [hasMark && (_jsx("a", { className: "countdown-brand-header__home", href: homeHref, children: logo !== null ? (_jsx("img", { className: "countdown-brand-header__logo", src: logo.src, alt: logo.alt })) : (_jsx("span", { children: name })) })), hasControls && _jsx("div", { className: "countdown-brand-header__actions", children: children })] }));
}
//# sourceMappingURL=TenantBrandHeader.js.map